module.exports = __webpack_public_path__ + "img/109.professionalism.c504908d.svg";